import { render, staticRenderFns } from "./UyapHacizTalepListForm.vue?vue&type=template&id=a0a07b42"
import script from "./UyapHacizTalepListForm.vue?vue&type=script&lang=ts"
export * from "./UyapHacizTalepListForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports